<template>
  <div class="error-state">
    <div class="content">

      <p class="title is-spaced">{{ $t(title) }}</p>
      <p class="subtitle">{{ $t(subtitle) }}</p>

      <div class="field is-grouped" v-if="$parent.update">
        <p class="control">
          <a class="button is-black is-small" @click="onRetry()">
            {{ $t('ui.buttons.retry') }}
            <span class="icon is-small">
              <i class="material-icons">&#xE5D5;</i>
            </span>
          </a>
        </p>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      required: true
    },
    isInsights: Boolean
  },

  data() {
    return {
      isLoading: false
    };
  },

  computed: {
    title () {
      return this.isInsights && this._type === 'error'
        ? `errors.states.${this._type}.title_insights`
        : `errors.states.${this._type}.title`
    },

    subtitle () {
      return `errors.states.${this._type}.subtitle`
    },

    _type() {
      return this.type.toLowerCase();
    }
  },

  methods: {
    onRetry() {
      const update = this.$parent.update || this.$parent.$parent.update
      update();
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~scss/utilities/initial-variables.scss';
@import '~scss/utilities/derived-variables.scss';

.error-state {
  width: 100%;
  height: 100%;
}

.content {
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 1.5rem;
  border: 1px dashed rgba($black, .16);
  text-align: center;

  &.is-small {
    padding-left: 1.5rem;
    padding-right: 1.5rem;

    .title {
      line-height: 1.17;
          
      &:not(:last-child) {
        margin-bottom: 1.5rem;
      }
    }
  }
}

.title,
.subtitle {
  color: rgba($black, .87);
}

.title {
  font-size: $size-large;
  font-weight: $weight-medium;
  line-height: 1.42;

  &:not(:last-child) {
    margin-bottom: .5rem;
  }
}

.subtitle {
  font-size: .875rem;
  line-height: 1.43;
  opacity: .64;

  &:not(:last-child) {
    margin-bottom: 1.5rem;
  }
}

.button {
  padding-top: .125rem;
  padding-bottom: .125rem;

  .icon {
    margin-left: .25rem !important;
  }
}
</style>